<script setup lang="ts">
import { ref, watch, onUnmounted } from 'vue'
import { useLoadingStore } from '@/stores/loading'

const loadingStore = useLoadingStore()
const progress = ref(0)
const isVisible = ref(false)
let intervalId: number | null = null

const startProgress = () => {
  isVisible.value = true
  progress.value = 0
  
  // Faster initial progress, then slow down
  intervalId = window.setInterval(() => {
    if (progress.value < 70) {
      progress.value += 10
    } else if (progress.value < 90) {
      progress.value += 1
    }
  }, 100)
}

const finishProgress = () => {
  if (intervalId) {
    clearInterval(intervalId)
    intervalId = null
  }
  
  progress.value = 100
  setTimeout(() => {
    isVisible.value = false
    setTimeout(() => {
      progress.value = 0
    }, 300)
  }, 500)
}

watch(() => loadingStore.isLoading, (isLoading) => {
  if (isLoading) {
    startProgress()
  } else {
    finishProgress()
  }
})

onUnmounted(() => {
  if (intervalId) clearInterval(intervalId)
})
</script>

<template>
  <div
    v-if="isVisible"
    class="fixed top-0 left-0 right-0 z-[101] h-1 bg-transparent pointer-events-none"
  >
    <div
      class="h-full bg-green-500 shadow-[0_0_10px_#22c55e] transition-all duration-300 ease-out"
      :style="{ width: `${progress}%` }"
    ></div>
  </div>
</template>

<style scoped>
.transition-all {
  transition-property: width, opacity;
}
</style>
